import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import LevelDescription from './LevelDescription';

interface Props {
  description?: string,
  level?: number,
  levelDescription?: string,
  name?: string,
  secondaryDescription?: string,
}

export default function TooltipDescription(props: Props) {
  const {
    description,
    secondaryDescription,
  } = props;

  return (
    <Fragment>
      <LevelDescription {...props} />
      <p dangerouslySetInnerHTML={{ __html: description ?? '' }} />
      <div className="tooltip__secondary-description" dangerouslySetInnerHTML={{ __html: secondaryDescription ?? '' }} />
    </Fragment>
  );
}

TooltipDescription.propTypes = {
  description: PropTypes.string,
  level: PropTypes.number,
  levelDescription: PropTypes.string,
  name: PropTypes.string,
  secondaryDescription: PropTypes.string,
};

TooltipDescription.defaultProps = {
  description: undefined,
  level: undefined,
  levelDescription: undefined,
  name: undefined,
  secondaryDescription: undefined,
};
